type Action = {
  digChs: string[];
};

export default (state: string[] = [], action: Action): string[] => {
  return action.digChs ? action.digChs : state;
};
